const data = {
  Lga: [
     { ledId: "0001", name: "Agege" },
    { ledId: "0002", name: "Ajeriomi-Ifelodun" },
    { ledId: "0003", name: "Alimosho" },
    { ledId: "0004", name: "Amuwo-Odofin" },
    { ledId: "0005", name: "Apapa" },
    { ledId: "0006", name: "Badagry" },
    { ledId: "0007", name: "Epe" },
    { ledId: "0008", name: "Eti-Osa" },
    { ledId: "0009", name: "Ibeju-Lekki" },
    { ledId: "0010", name: "Ifako-Ijaye" },
    { ledId: "0011", name: "Ikeja" },
    { ledId: "0012", name: "Ikorodu" },
    { ledId: "0013", name: "Kosofe" },
    { ledId: "0014", name: "Lagos Island" },
    { ledId: "0015", name: "Lagos Mainland" },
    { ledId: "0016", name: "Mushin" },
    { ledId: "0017", name: "Ojo" },
    { ledId: "0018", name: "Oshodi-Isolo" },
    { ledId: "0019", name: "Somolu" },
    { ledId: "0020", name: "Surulere" },
   
  ],

  // No others here
  LgaForPublic: [
    {ledId: "0001", name:"Grade Level 8 and above: (Compulsory)"},
    {ledId: "0002", name:"Grade Level 06 & 07(executive"},
    {ledId: "0003", name:"CLERICAL ASSISTANCE (Grade Level 02-03)"},
    {ledId: "0004", name:"C.O II(Grade Level 04-05)"},
    {ledId: "0005", name:"EXTERNAL CONFIDENTIAL SECRETARIES(C.S) II "},
    {ledId: "0006", name:"EXTERNAL CONFIDENTIAL SECRETARIES(C.S) III "},
    {ledId: "0007", name:"EXTERNAL CONFIDENTIAL SECRETARIES(C.S)IV "}
  ],

  Tedac: [
    { cert: "Lieu Of Certificates" },
    { cert: "True Copy Of Certificates" },
    { cert: "Grade II Certificates" },
    { cert: "Certificates Issue By The Board" },
  ],

  testType: [
    { name: "Trade Test" }, // price only #5,000
    { name: "External Secteriat" },
    { name: "Executive Admin" },
  ],

  tradeTest: [{ name: "Stage I" }, { name: "Stage II" }, { name: "Stage III" }],
  externalSec: [{ name: "CS II" }, { name: "CS III" }],
  execAdmin: [
    { name: "Confirmed/Combined I" },
    { name: "Confirmed/Combined II" },
    { name: "Confirmed/Combined III" },
  ],
  price: [{ fee: "₦5,000" }, { fee: "₦10,000" }],

  modeOfPayment: [
    { paymentType: "Bank" },
    { paymentType: "Pos" },
    { paymentType: "Online" },
  ],
   gender: [
    {value: "Male"},
    {value: "Female"},
   ],

   stages: [
    {value: "Stage 3: Apprentice, beginner"},
    {value: "Stage 2: With Certificate, Intermediate"},
    {value: "Stage 1: Professional, teaches apprentices"},
   ]
};
export default data;
